// Remux reaps unclaimed HLS prewarms after 90 seconds. Keep a 15-second
// safety margin so React Query can never hand Player an apparently-fresh
// PlaybackInfo response whose PlaySessionId has already been reaped.
export const PLAYER_PLAYBACK_INFO_STALE_MS = 75 * 1000;
export const PLAYER_SOURCE_CATALOG_STALE_MS = 5 * 60 * 1000;

export const playerPlaybackInfoQueryKey = (
  itemId: string,
  mediaSourceId = "",
) => ["player", "playback-info", itemId, mediaSourceId] as const;

export const playerSourceCatalogQueryKey = (itemId: string) =>
  ["player", "source-catalog", itemId] as const;
